import React, { Component } from 'react';
import './index.css';
import {
  Container,
  LogosContainer,
  AppTitle,
  Anchor,
} from './styledComponents';
import Banner from '../../components/Banner';
import PageSizer from '../../components/PageSizer';
import Footer from '../../components/Footer';
import Logo from '../../components/Logo';
import SearchInvoiceForm from '../../components/SearchInvoiceForm';
import Results from '../../components/Results';
import ContactForm from '../../components/ContactForm';
import RyderLogo from '../../images/ryder_logo.png';
import LlowesLogo from '../../images/llowes_logo.png';

class App extends Component {
  state = {
    currentPage: 'search',
    invoice: {},
    accountNumber: '',
  };
  changePage = (currentPage, invoice, accountNumber) => {
    this.setState({
      currentPage: currentPage,
      invoice: invoice ? invoice : {},
      accountNumber: accountNumber ? accountNumber : '',
    });
  };
  render() {
    const {
      currentPage,
      invoice,
      accountNumber,
    } = this.state;
    return (
      <Container>
        <Banner>
          <LogosContainer>
            <Logo src={RyderLogo} alt="Ryder logo" />
            <Logo src={LlowesLogo} alt="Llowes logo" />
          </LogosContainer>
          <PageSizer className="headerSizer">
            <AppTitle>Ryder Rental - Lowes Payment Portal</AppTitle>
            <p className="App-intro">{'Welcome to the payment portal for Ryder\'s Lowes customers. Please use the invoice lookup below to retrieve and make payments towards Ryder Rental invoices.'}</p>
          </PageSizer>
        </Banner>
        <PageSizer className="mainContainer">
          {{
            search: <SearchInvoiceForm onSubmit={this.changePage} />,
            results: [
              <Results
                key={'results'}
                onBack={this.changePage}
                onClickPay={this.changePage}
                invoice={invoice}
                accountNumber={accountNumber}
              />,
              <ContactForm
                key={'contact-form'}
                invoice={invoice}
              />
            ],
            payment: [
              <Results
                key={'results'}
                onBack={this.changePage}
                confirmTotalOwed
                invoice={invoice}
                accountNumber={accountNumber}
              />
            ],
          }[currentPage]}
        </PageSizer>
        <Footer>
          <Anchor href="https://reservations.ryder.com/en/privacy-policy" target="_blank" className="left-footer">{'Privacy Policy'}</Anchor>
          {' | '}
          <Anchor href="https://reservations.ryder.com/en/terms-of-use" target="_blank" className="right-footer">{'Terms of Use'}</Anchor>
        </Footer>
      </Container>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/index.js